import _ from "lodash";
import React from "react";
import classes from "./AddItemsModal.scss";
import PropTypes from "prop-types";
import { SelectDropdown, Modal, Button } from "@toddle-edu/ds-web";
import classNames from "classnames";

const AddItemsModal = props => {
  const {
    items,
    onClickButton1,
    onClickButton2,
    buttonText1,
    buttonText2,
    modalTitle,
    searchPlaceholderText,
    isCreateItems,
    onCreateItemClick,
    selectedItemsList,
    setSelectedItemsList,
    userNote = "",
    createText,
  } = props;

  const onSearchItemClick = item => {
    setSelectedItemsList(item);
  };

  return (
    <Modal width="480px" height="600px" onClose={onClickButton1}>
      <Modal.Header>{modalTitle}</Modal.Header>
      <Modal.Body>
        <div>
          <div className={classNames("text-body-1", classes.userNoteContainer)}>
            {userNote}
          </div>
          <div className={classes.dropdownContainer}>
            <SelectDropdown
              options={items}
              onChange={onSearchItemClick}
              value={selectedItemsList}
              isMulti={true}
              placeholder={searchPlaceholderText}
              isCreatable={isCreateItems}
              createText={createText}
              onCreateOption={onCreateItemClick}
              isSelectAllEnabled={false}
              showCheckbox={true}
              showOverflowingTagsCount={true}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className={classes.footerContainer}>
          <Button
            variant="outlined-subtle"
            size="large"
            onClick={onClickButton1}
          >
            {buttonText1}
          </Button>
          <Button
            variant="progressive"
            size="large"
            onClick={onClickButton2}
            disabled={_.isEmpty(selectedItemsList)}
          >
            {buttonText2}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

AddItemsModal.defaultProps = {
  buttonText1: "Cancel",
  buttonText2: "Add",
  modalTitle: "Add Items",
  searchPlaceholderText: "Search an item",
  isCreateItems: true,
  createText: "Create",
  userNote: "",
};
AddItemsModal.propTypes = {
  buttonText1: PropTypes.string,
  buttonText2: PropTypes.string,
  modalTitle: PropTypes.string,
  searchPlaceholderText: PropTypes.string,
  isCreateItems: PropTypes.bool,
  selectedItemsList: PropTypes.array,
  onClickButton1: PropTypes.func,
  onClickButton2: PropTypes.func,
  onCreateItemClick: PropTypes.func,
  setSelectedItemsList: PropTypes.func,
  createText: PropTypes.string,
  userNote: PropTypes.string,
};
export default AddItemsModal;
